import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'
import type { BarChartBlock as BarChartBlockType } from '../types/report'
import { mergeSeries, SERIES_COLORS } from './chartData'
import styles from './blocks.module.css'

export function BarChartBlock({ block }: { block: BarChartBlockType }) {
  const data = mergeSeries(block.series)
  return (
    <div className={styles.block}>
      {block.title ? <div className={styles.blockTitle}>{block.title}</div> : null}
      <div className={styles.chartCanvas}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 8, right: 24, bottom: block.x_label ? 52 : 32, left: 16 }}>
            <CartesianGrid stroke="var(--hairline)" strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="x"
              stroke="var(--fg-subtle)"
              tick={{ fontSize: 11, fill: 'var(--fg-subtle)' }}
              label={
                block.x_label
                  ? { value: block.x_label, position: 'insideBottom', offset: -16, fill: 'var(--fg-subtle)', fontSize: 11 }
                  : undefined
              }
            />
            <YAxis
              stroke="var(--fg-subtle)"
              tick={{ fontSize: 11, fill: 'var(--fg-subtle)' }}
              label={
                block.y_label
                  ? { value: block.y_label, angle: -90, position: 'insideLeft', offset: 8, fill: 'var(--fg-subtle)', fontSize: 11 }
                  : undefined
              }
            />
            <Tooltip
              contentStyle={{
                background: 'var(--surface-1)',
                border: '1px solid var(--hairline)',
                borderRadius: 8,
                color: 'var(--fg-default)',
              }}
              cursor={{ fill: 'var(--hairline)', opacity: 0.3 }}
            />
            <Legend
              verticalAlign="top"
              wrapperStyle={{ fontSize: 12, paddingBottom: 8 }}
              formatter={(value) => <span style={{ color: 'var(--fg-default)' }}>{value}</span>}
            />
            {block.series.map((s, i) => (
              <Bar key={s.name} dataKey={s.name} fill={SERIES_COLORS[i % SERIES_COLORS.length]} />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
